import { Component, OnInit, ElementRef, Inject } from '@angular/core';
import { serviceURLService } from '../service/serviceURL';
import { Router } from '@angular/router';
import { DOCUMENT, formatDate } from '@angular/common';
import { Subject } from 'rxjs/internal/Subject';
import { takeUntil } from 'rxjs/internal/operators/takeUntil';

// import { $ } from 'protractor';
declare var $: any;


@Component({
  selector: 'app-team-check-in',
  templateUrl: './team-check-in.component.html',
  styleUrls: ['./team-check-in.component.css']
})
export class TeamCheckInComponent implements OnInit {
  data: any = {};
  userID: any;
  name: any;
  teamMemberDetails: Array<any> = [];
  teamMemberList: Array<any> = [];
  supervisorCheckList: Array<any> = [];
  leaveLeft: Array<any> = [];
  showRows: any = [];
  lat: any;
  lng: any;
  checkInDetails: any;
  updatedTime: any;
  error: any;
  modalHeaderDetails: any;
  requestTypeIn: any;
  rangeIn: any;
  requestTimeIn: any;
  pandingIdIn: any;
  requestTypeOut: any;
  rangeOut: any;
  requestTimeOut: any;
  pandingIdOut: any;
  teamMemberUserId: any;
  checkInModalData: any = [];
  checkOutModalData: any = [];
  absentModalData: any = [];
  approvalStatus: any;
  memberUserID: any;
  pendingLeaveModalData: any;
  leaveDate: number;
  requestTypeLeave: any;
  requestTimeLeave: any;
  pandingIdLeave: any;
  checOutData: any = [];
  checInData: any = [];
  absentData: any = [];
  pendingLeavesRequestData: any = [];
  checInDatalengthArr = [];
  checOutDatalengthArr = [];
  absentDatalengthArr = [];
  checLeaveDatalengthArr = [];
  pendingLeaveStatus: string;
  supervisorComment: any;
  storedDates: Array<any> = [];
  minimumDate = new Date();
  selectedDates: any = [];
  value: Date[];
  memberPopupUserId: any;
  supervisorCheck: any;
  daysOnTimeAndLeavesLeft: any;
  isTracking: boolean;
  checkOutModalHeaderData: any;
  showIndicator = false;
  noWrapSlides = false;
  slides: { image: string }[] = [];
  activeSlideIndex = 0;
  checkInModalHeaderData: any;
  leaveModalHeaderData: any;
  leaveDatesSliderHeader: any;
  successMessageCheckIn: any;
  successMessageCheckOut: any;
  locationParam: { "latitude": any; "longitude": any; };
  loading: boolean;
  particularMemberId: any;
  pendingLeaveId: number;
  particularUserCheckinData: any = [];
  particularUserCheckOutData: any = [];
  particularUserAbsentData: any = [];
  particularUserLeaveData: any = [];
  currentPage: number = 1;
  recordsPerPage: number = 4;
  checkInfo = true;
  selectedUserId: string
  checkInType: string;
  confirmationMessage: string;
  private onDestroy$: Subject<void> = new Subject<void>();  

  constructor(private router: Router, private serviceURLService: serviceURLService, private elem: ElementRef, @Inject(DOCUMENT) document) {
    this.userID = localStorage.getItem('userID');
    this.name = localStorage.getItem('name');

    // if (navigator.geolocation) {
    //   this.isTracking = true;
    //   navigator.geolocation.watchPosition((pos) => {
    //     this.showTrackingPosition(pos);
    //   });
    // }
  }
  checkInfoToggle() {
    setTimeout(() => {
      this.checkInfo = false
    },3000)
  }
  get totalPagesCheckIn(): number[] {
    const totalItems = this.particularUserCheckinData.length;
    const totalPages = Math.ceil(totalItems / this.recordsPerPage);
    return Array.from({ length: totalPages }, (_, i) => i + 1);
  }

  get totalPagesCheckOut(): number[] {
    const totalItems = this.particularUserCheckOutData.length;
    const totalPages = Math.ceil(totalItems / this.recordsPerPage);
    return Array.from({ length: totalPages }, (_, i) => i + 1);
  }

  get totalPagesAbsent(): number[] {
    const totalItems = this.particularUserAbsentData.length;
    const totalPages = Math.ceil(totalItems / this.recordsPerPage);
    return Array.from({ length: totalPages }, (_, i) => i + 1);
  }

  get totalPagesLeave(): number[] {
    const totalItems = this.particularUserLeaveData.length;
    const totalPages = Math.ceil(totalItems / this.recordsPerPage);
    return Array.from({ length: totalPages }, (_, i) => i + 1);
  }
  
  get paginatedDataCheckIn() {
    const startIndex = (this.currentPage - 1) * this.recordsPerPage;
    const endIndex = startIndex + this.recordsPerPage;
    return this.particularUserCheckinData.slice(startIndex, endIndex);
  }

  get paginatedDataCheckOut() {
    const startIndex = (this.currentPage - 1) * this.recordsPerPage;
    const endIndex = startIndex + this.recordsPerPage;
    return this.particularUserCheckOutData.slice(startIndex, endIndex);
  }

  get paginatedDataAbsent() {
    const startIndex = (this.currentPage - 1) * this.recordsPerPage;
    const endIndex = startIndex + this.recordsPerPage;
    return this.particularUserAbsentData.slice(startIndex, endIndex);
  }

  get paginateDataLeave(){
    const startIndex = (this.currentPage - 1) * this.recordsPerPage;
    const endIndex = startIndex + this.recordsPerPage;
    return this.particularUserLeaveData.slice(startIndex, endIndex);
  }

  toggleStatus(checkin, status) {
    // If the currently selected status is the same as the clicked one, deselect it
    if (checkin.status === status) {
        checkin.status = ''; // Deselect
    } else {
        checkin.status = status; // Select the new status
    }
  }

  ngOnInit() {
    this.getTeamMember();
    this.approvalStatus = "OK";
    this.pendingLeaveStatus = "Paid"
    //this.getLocation();
  }

  getTeamMember() {
    this.data = {
      "updatedTime": null,
    }

    let selectedDates = [];

    this.loading=true;
    this.serviceURLService.getTeam(this.data, this.userID).subscribe((successData: any) => {
      this.loading=false;
      this.teamMemberList = [];
      this.supervisorCheckList = [];
      this.checkInModalData = successData.response.pendingRequests.pendingCheckInData;
      this.checkOutModalData = successData.response.pendingRequests.pendingCheckOutData;
      this.absentModalData = successData.response.pendingRequests.pendingAbsentData;
      this.pendingLeaveModalData = successData.response.pendingRequests.pendingLeavesData;
      this.daysOnTimeAndLeavesLeft = successData.response.daysOnTimeAndLeavesLeft;

      for (let i = 0; i < (successData.response.teamMembersToBeAdded).length; i++) {
        for (let j = 0; j < (successData.response.daysOnTimeAndLeavesLeft).length; j++) {
          if (successData.response.teamMembersToBeAdded[i].userId === successData.response.daysOnTimeAndLeavesLeft[j].userId) {

            this.teamMemberList.push({
              name: successData.response.teamMembersToBeAdded[i].name,
              leaveLeftCount: successData.response.daysOnTimeAndLeavesLeft[j].leavesLeft,
              countDaysOnTime: successData.response.daysOnTimeAndLeavesLeft[j].daysOnTime,
              memberUserID: successData.response.teamMembersToBeAdded[i].userId,
              memberSupervisorCheck: successData.response.teamMembersToBeAdded[i].isSupervisor
            })

            this.teamMemberUserId = this.teamMemberList[i].memberUserID;
            //this.teamMemberList = this.sortList(this.teamMemberList);
            //console.log(this.teamMemberList)
            //this.userId.push(this.teamMemberUserId);
            this.checkPendingRequest(this.teamMemberUserId)

          }
        }


      }



      this.teamMemberList.forEach((currentTeamMember, indexForTeam) => {
        this.checkInModalData.forEach((checkIn, indexForCheckin) => {
          if (currentTeamMember.memberUserID == checkIn.userId) {
            this.teamMemberList[indexForTeam].isCheckIn = true;
          }
        });

        this.checkOutModalData.forEach((checkOut, indexForCheckout) => {
          if (currentTeamMember.memberUserID == checkOut.userId) {
            this.teamMemberList[indexForTeam].isCheckOut = true;
          }
        });

        this.absentModalData.forEach((absent, indexForCheckout) => {
          if (currentTeamMember.memberUserID == absent.userId) {
            this.teamMemberList[indexForTeam].isAbsent = true;
          }
        });
        this.pendingLeaveModalData.forEach((currentLeave, indexForCheckout) => {
          if (currentTeamMember.memberUserID == currentLeave.userId) {
            this.teamMemberList[indexForTeam].isLeave = true;
          }
        });
      });
      //this.teamMemberList = this.sortList(this.teamMemberList);      
    }, errorData => {
      if (errorData.error.status === 401) {
        this.router.navigate(['/login']);
        console.log("Please login first");
      } else if (errorData.error.status === 403 || errorData.error.status === 400) {
        this.error = errorData.error.message;
        console.log("ERROR: ", this.error);
      }
    })
  }
  sortList(data) {
    data.sort(function (item, itemSort) {
      return item.name.localeCompare(itemSort.name);
    })
    return data;

    //console.log('Data', data);
  }
  checkPendingRequest(memberUserID) {

    this.checInData = this.checkInModalData.filter((e) => {
      return memberUserID == e.userId;
    })
    this.checInDatalengthArr.push(this.checInData.length);


    this.checOutData = this.checkOutModalData.filter((e) => {
      return memberUserID == e.userId;
    })
    this.checOutDatalengthArr.push(this.checOutData.length);

    this.absentData = this.absentModalData.filter((e) => {
      return memberUserID == e.userId;
    })
    this.absentDatalengthArr.push(this.absentData.length);

    this.pendingLeavesRequestData = this.pendingLeaveModalData.filter((e) => {
      return memberUserID == e.userId;
    })
    this.checLeaveDatalengthArr.push(this.pendingLeavesRequestData.length);
  }
  /* To update Check-In, Check-Out request approval popup data update*/
  updateArrayAfterDelete(data, deletedId) {
    let index;
    // Uncomment it for slider functionaltiy
    //data.splice( this.activeSlideIndex, 1);
    for (let i = 0; i < data.length; i++) {
      if (data[i].pendingRequestId === deletedId) {
        index = i;

      }
    }
    // Uncomment it for slider functionaltiy
    //index.splice( this.activeSlideIndex, 1);
    return data.filter((value, i) => i !== index);
  }
  /*Check-In request approval by supervisor functionality start*/
  popolateUpdatedCheckInData(dataCheckInReq) {
    console.log(dataCheckInReq);
    if (dataCheckInReq.length != 0) {
      $('#supervisorCheckInModal').modal('show');
      // Uncomment it for slider functionaltiy
      //this.checkInModalHeaderData = dataCheckInReq;
      this.rangeIn = Math.round(dataCheckInReq[0].range);
      this.requestTypeIn = dataCheckInReq[0].pendingRequestType;
      this.requestTimeIn = dataCheckInReq[0].dateOfCheckIn;
      this.pandingIdIn = dataCheckInReq[0].pendingRequestId;
      this.currentPage = 1
      this.checkInfo = true;
      this.checkInfoToggle();
    } else {
      $('#supervisorCheckInModal').modal('hide');
      this.getTeamMember();
      //$("#noDataFoundModal").modal('show');
      //window.location.reload();
    }
  }
  openCheckInModal(userId) {
    this.memberPopupUserId = userId;
    this.particularUserCheckinData = [];
    for (const checkIn of this.checkInModalData) {
      if (userId === checkIn.userId) {
        checkIn.status = "OK";
        checkIn.statusLate = false;
        checkIn.statusHalfDay = false;
        checkIn.statusUnapproved = false;
        this.particularUserCheckinData.push(checkIn);
      }
    }
    console.log(this.particularUserCheckinData);
    this.popolateUpdatedCheckInData(this.particularUserCheckinData);
  }

  supervisorCheckIn(userID) {
    let elements: any = {};
    elements = document.getElementsByClassName('item carousel-item active');
    this.pendingLeaveId = elements[0].id;
    this.data = {
      "pendingId": this.pendingLeaveId,
      "approvalStatus": this.approvalStatus,
      "approvedBy": this.name
    }
    this.serviceURLService.checkInSupervisor(this.data, this.teamMemberUserId).pipe(takeUntil(this.onDestroy$)).subscribe((successData: any) => {
      console.log("Supervisor Checked-in successfully");
      // Uncomment it for slider functionaltiy
      //this.checkInModalHeaderData.splice( this.activeSlideIndex, 1);
      this.particularUserCheckinData = this.updateArrayAfterDelete(this.particularUserCheckinData, this.pendingLeaveId);
      this.checkInModalData = this.updateArrayAfterDelete(this.checkInModalData, this.pendingLeaveId);

      this.popolateUpdatedCheckInData(this.particularUserCheckinData);
      this.getTeamMember();
     // $('#supervisorCheckInModal').modal('hide');
    }, errorData => {
      if (errorData.error.status === 401) {
        this.router.navigate(['/login']);
      } else if (errorData.error.status === 403 || errorData.error.status === 400) {

        this.error = errorData.error.message;
      }
    })
  }
  /*Check-In request approval by supervisor functionality end*/

  /*Check-OUT request approval by supervisor functionality start*/
  popolateUpdatedCheckOutData(dataCheckOutReq) {
    if (dataCheckOutReq.length != 0) {
      $('#supervisorCheckOutModal').modal('show');
      // Uncomment it for slider functionaltiy
      //this.checkOutModalHeaderData = dataCheckOutReq;
      //console.log("check sdcdscd ", this.checkOutModalHeaderData)
      this.rangeOut = Math.round(dataCheckOutReq[0].range);
      this.requestTypeOut = dataCheckOutReq[0].pendingRequestType;
      this.requestTimeOut = dataCheckOutReq[0].dateOfCheckIn;
      this.pandingIdOut = dataCheckOutReq[0].pendingRequestId;
      this.currentPage = 1
      this.checkInfo = true;
      this.checkInfoToggle();
    } else {
      $('#supervisorCheckOutModal').modal('hide');
      this.getTeamMember();
      // $("#noDataFoundModal").modal('show');
      // window.location.reload();
    }
  }
  openCheckOutModal(userId) {
    this.memberPopupUserId = userId;
    this.particularUserCheckOutData = [];
    for (const checkIn of this.checkOutModalData) {
      if (userId === checkIn.userId) {
        checkIn.status = "OK";
        checkIn.statusLate = false;
        checkIn.statusHalfDay = false;
        checkIn.statusUnapproved = false;
        this.particularUserCheckOutData.push(checkIn);
      }
    }
    this.popolateUpdatedCheckOutData(this.particularUserCheckOutData);
  }

  populateAbsentApprovalData(dataAbsentReq) {
    if (dataAbsentReq.length != 0) {
      $('#supervisorAbsentModal').modal('show');
      this.currentPage = 1
      this.checkInfo = true;
      this.checkInfoToggle();
    } else {
      $('#supervisorAbsentModal').modal('hide');
      this.getTeamMember();
    }
  }
  openAbsentApprovalModal(userId) {
    this.memberPopupUserId = userId;
    this.particularUserAbsentData = [];
    for (const checkIn of this.absentModalData) {
      if (userId === checkIn.userId) {
        checkIn.status = "OK";
        checkIn.statusLate = false;
        checkIn.statusHalfDay = false;
        checkIn.statusUnapproved = false;
        if(checkIn.checkInTime !== null && checkIn.checkOutTime === null){
          checkIn.checkInValue = checkIn.checkInTime;
          checkIn.checkOutValue = "Pending";
        }
        if(checkIn.checkInTime === null && checkIn.checkOutTime === null){
          checkIn.checkInValue = "Absent";
          checkIn.checkOutValue = "Absent";
        }
        this.particularUserAbsentData.push(checkIn);
      }
    }
    this.populateAbsentApprovalData(this.particularUserAbsentData);
  }
  supervisorCheckOut(userID) {
    let elements: any = {};
    elements = document.getElementsByClassName('item carousel-item active');
    this.pendingLeaveId = elements[0].id;
    this.data = {
      "pendingId": this.pendingLeaveId,
      "approvalStatus": this.approvalStatus,
      "approvedBy": this.name
    }
    this.serviceURLService.checkOutSupervisor(this.data, this.teamMemberUserId).pipe(takeUntil(this.onDestroy$)).subscribe((successData: any) => {
      console.log("Supervisor Checked-out successfully");
      this.checkOutModalData = this.updateArrayAfterDelete(this.checkOutModalData, this.pendingLeaveId);
      this.particularUserCheckOutData = this.updateArrayAfterDelete(this.particularUserCheckOutData, this.pendingLeaveId);
      // Uncomment it for slider functionaltiy
      //this.getTeamMember();
      this.popolateUpdatedCheckOutData(this.particularUserCheckOutData);
      // Uncomment it for slider functionaltiy
      //this.checkOutModalHeaderData.splice( this.activeSlideIndex, 1);
      this.getTeamMember();
     // $('#supervisorCheckOutModal').modal('hide');
    }, errorData => {
      if (errorData.error.status === 401) {
        this.router.navigate(['/login']);
      } else if (errorData.error.status === 403 || errorData.error.status === 400) {
        this.error = errorData.error.message;
      }
    })
  }

  /*Check-OUT request approval by supervisor functionality end*/

  /*Leave request approval by supervisor functionality start*/
  popolateUpdatedLeaveData(dataLeaveReq) {
    console.log("In populate leave data ", dataLeaveReq)
    if (dataLeaveReq.length != 0) {
      $('#supervisorLeaveApproveModal').modal('show');
      // this.rangeOut = Math.round(dataLeaveReq[0].range);
      // this.requestTypeOut = dataLeaveReq[0].pendingRequestType;
      // this.requestTimeOut = dataLeaveReq[0].dateOfCheckIn;
      // this.pandingIdOut = dataLeaveReq[0].pendingRequestId;

      //this.leaveDate = Math.round(pendingLeavesRequestData[0].dateOfLeave);
      this.leaveModalHeaderData = dataLeaveReq;
      this.leaveDatesSliderHeader = dataLeaveReq;
      // for (let leaves of this.leaveDatesSliderHeader) {
      //       var maxDate = this.formatDate(new Date(Math.max.apply(null, leaves.dateOfLeave)));
      //       var minDate = this.formatDate(new Date(Math.min.apply(null, leaves.dateOfLeave)));
      //       leaves['groupDate'] = minDate + ' - ' + maxDate;
      // }
      this.requestTypeLeave = dataLeaveReq[0].pendingRequestType;
      this.requestTimeLeave = new Date(this.pendingLeavesRequestData[0].dateOfLeave[0]);
      this.pandingIdLeave = dataLeaveReq[0].pendingRequestId;
      this.supervisorComment = dataLeaveReq[0].comment;
      this.currentPage = 1
      this.checkInfo = true;
      this.checkInfoToggle();
    } else {
      $('#supervisorLeaveApproveModal').modal('hide');
      this.getTeamMember();
    }
  }
  //comment to enable slider functionality start (updated code available below)
  // openLeaveApproveModal(userId) {

  //   this.pendingLeavesRequestData = this.pendingLeaveModalData.filter((e) => {
  //     return userId == e.userId;
  //   })
  //   if (this.pendingLeavesRequestData.length != 0) {
  //     $('#supervisorLeaveApproveModal').modal('show');
  //     this.requestTypeLeave = this.pendingLeavesRequestData[0].pendingRequestType;
  //     this.requestTimeLeave = new Date(this.pendingLeavesRequestData[0].dateOfLeave[0]);
  //     this.pandingIdLeave = this.pendingLeavesRequestData[0].pendingRequestId;
  //     this.supervisorComment = this.pendingLeavesRequestData[0].comment;
  //   }
  //   else {
  //     //$("#noDataFoundModal").modal('show');
  //   }
  // }
  // supervisorLeaveApprove(teamMemberUserId) {
  //   this.data = {
  //     "pendingId": this.pandingIdLeave,
  //     "approvalStatus": this.pendingLeaveStatus,
  //     "approvedBy": this.name,
  //     "supervisorComment": this.supervisorComment
  //   }
  //   this.serviceURLService.LeaveApproveSupervisor(this.data, this.teamMemberUserId).subscribe((successData: any) => {
  //     console.log("Leave approved successfully");
  //     //console.log("data " + this.data)
  //   }, errorData => {
  //     if (errorData.error.status === 401) {
  //       this.router.navigate(['/login']);
  //     } else if (errorData.error.status === 403 || errorData.error.status === 400) {
  //       this.error = errorData.error.message;
  //     }
  //   })
  // }
  //comment to enable slider functionality end (updated code available below)

  formatDate(date) {
    let updatedDate = date.getDate() + '-' + (date.getMonth() + 1) + '-' + date.getFullYear();
    return updatedDate;
  }

  //Uncomment to enable slider functionality start (updated code is here)
  openLeaveApproveModal(userId) {
    this.particularUserLeaveData = [];
    console.log("In open leave modal user ID", userId)
    this.memberPopupUserId = userId;
    console.log("In open leave modal member pop user ID", this.memberPopupUserId)
    console.log("pending leave req data ", this.pendingLeavesRequestData);
    this.pendingLeavesRequestData = this.pendingLeaveModalData.filter((e) => {
      return userId == e.userId;
    })
    this.particularUserLeaveData = this.pendingLeavesRequestData;
    this.popolateUpdatedLeaveData(this.particularUserLeaveData);
  }

  submitLeaveApprove() {
    let dataToSubmit = []
    this.paginateDataLeave.map(checkin => {
      if (!!checkin.status && checkin.status === "Paid") {
        dataToSubmit.push({
          "pendingId": checkin.pendingRequestId,
          "approvalStatus": "Paid",
          "approvedBy": this.name,
          "supervisorComment": checkin.comment
        })
      } else if(!!checkin.status && checkin.status === "Unpaid") {
        dataToSubmit.push({
          "pendingId": checkin.pendingRequestId,
          "approvalStatus": "Unpaid",
          "approvedBy": this.name,
          "supervisorComment": checkin.comment
        })
      }else if(!!checkin.status && checkin.status === "Rejected") {
        dataToSubmit.push({
          "pendingId": checkin.pendingRequestId,
          "approvalStatus": "Rejected",
          "approvedBy": this.name,
          "supervisorComment": checkin.comment
        })
      }
    }
    )

    dataToSubmit = dataToSubmit.filter(item => item.approvalStatus !== '');
    if (dataToSubmit.length > 0) {
      this.serviceURLService.LeaveApproveSupervisor(dataToSubmit, this.memberPopupUserId).pipe(takeUntil(this.onDestroy$)).subscribe((successData: any) => {
        console.log("Leave approved successfully");
        const pendingIds = new Set(dataToSubmit.map(item => item.pendingId));
        this.pendingLeaveModalData = this.pendingLeaveModalData.filter(item => !pendingIds.has(item.pendingRequestId));
        this.openLeaveApproveModal(this.memberPopupUserId);
      }, errorData => {
        if (errorData.error.status === 401) {
          this.router.navigate(['/login']);
        } else if (errorData.error.status === 403 || errorData.error.status === 400) {
          this.error = errorData.error.message;
        }
      })
    }

  }
  supervisorLeaveApprove() {
    let elements: any = {};
    elements = document.getElementsByClassName('item carousel-item active');
    this.pendingLeaveId = elements[0].id;
    this.data = {
      "pendingId": this.pendingLeaveId,
      "approvalStatus": this.approvalStatus,
      "approvedBy": this.name,
      "supervisorComment": this.supervisorComment
    }
    this.serviceURLService.LeaveApproveSupervisor(this.data, this.memberPopupUserId).pipe(takeUntil(this.onDestroy$)).subscribe((successData: any) => {
      console.log("Leave approved successfully");
      //console.log("data " + this.data)
      this.pendingLeaveModalData = this.updateArrayAfterDelete(this.pendingLeaveModalData, this.pendingLeaveId);
      this.pendingLeavesRequestData = this.updateArrayAfterDelete(this.pendingLeavesRequestData, this.pendingLeaveId);
      this.popolateUpdatedLeaveData(this.pendingLeavesRequestData);
      // setTimeout(() => {
      //   window.location.reload();
      // }, 1000);
    }, errorData => {
      if (errorData.error.status === 401) {
        this.router.navigate(['/login']);
      } else if (errorData.error.status === 403 || errorData.error.status === 400) {
        this.error = errorData.error.message;
      }
    })
  }
  //Uncomment to enable slider functionality end (updated code is here)
  /*Leave request approval by supervisor functionality end*/
  showCheckMark() {
    $(".hiddenCheckMark").css("display", "block");
  }


  public getLocation(location) {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(pos => {

        var lng = +pos.coords.longitude;
        var lat = +pos.coords.latitude;
        var locationParam = {
          "latitude": lat,
          "longitude": lng,
        }

        if (location)
          location(locationParam);
        // return locationParam;
        //let location = new google.maps.LatLng(pos.coords.latitude, pos.coords.longitude);
      });

    }
  }

  teamMemberCheckIn(userID) {
    this.loading = true;
    this.getLocation(res => {
      this.data = {
        "latitude": res.latitude,
        "longitude": res.longitude,
        "isCheckInFromWeb": 'false'
      }
      this.serviceURLService.checkIn(this.data, userID).pipe(takeUntil(this.onDestroy$)).subscribe((successData: any) => {
        console.log("Checked-in successfully");
        this.loading = false;
        this.successMessageCheckIn = successData.message;
        $("#checkInModal").modal('show');
        //this.showCheckMark();
      }, errorData => {
        if (errorData.error.status === 401) {
          this.router.navigate(['/login']);
        } else if (errorData.error.status === 403 || errorData.error.status === 400) {
          this.loading = false;
          this.error = errorData.error.message;
          $("#checkInModal").modal('show');
        }
      })
    });
  }

  teamMemberCheckOut(userID) {
    this.loading = true;
    this.getLocation(res => {
      this.data = {
        "latitude": res.latitude,
        "longitude": res.longitude,
        "isCheckOutFromWeb": 'false'
      }
      this.serviceURLService.checkOut(this.data, userID).pipe(takeUntil(this.onDestroy$)).subscribe((successData: any) => {
        console.log("Checked-out successfully");
        this.loading = false;
        this.successMessageCheckOut = successData.message;
        $("#checkInModal").modal('show');
      }, errorData => {
        if (errorData.error.status === 401) {
          this.router.navigate(['/login']);
        } else if (errorData.error.status === 403 || errorData.error.status === 400) {
          this.loading = false;
          this.error = errorData.error.message;
          $("#checkInModal").modal('show');
        }
      })
    });
  }

  openConfirmModal(userID,type) {
    this.selectedUserId = userID;
    this.checkInType = type;
    if(type === "IN") {
      this.confirmationMessage = `This will mark the Employee's Attendance as In, which cannot be undone.  Are you sure you want to proceed?`
    }else{
      this.confirmationMessage = `This will mark the Employee's Attendance as Out, which cannot be undone.  Are you sure you want to proceed?`
    }
    ($('#confirmModal') as any).modal('show');
  }

  confirmCheckIn() {
    if (this.selectedUserId && this.checkInType === "IN") {
      this.teamMemberCheckIn(this.selectedUserId);
    }
    if(this.selectedUserId && this.checkInType === "OUT") {
      this.teamMemberCheckOut(this.selectedUserId);
    }
    ($('#confirmModal') as any).modal('hide');
  }
  
  teamMemberLeaveCalender(userID) {
    this.router.navigate(['/teamMemberCalender']);
  }

  getTeamListAgain(userID) {
    this.loading = true;
    this.data = {
      "updatedTime": null,
    }

    let selectedDates = [];


    this.serviceURLService.getTeam(this.data, userID).pipe(takeUntil(this.onDestroy$)).subscribe((successData: any) => {

      this.teamMemberList = [];
      this.supervisorCheckList = [];
      this.checkInModalData = successData.response.pendingRequests.pendingCheckInData;
      this.checkOutModalData = successData.response.pendingRequests.pendingCheckOutData;
      this.absentModalData = successData.response.pendingRequests.pendingAbsentData;
      this.pendingLeaveModalData = successData.response.pendingRequests.pendingLeavesData;
      this.daysOnTimeAndLeavesLeft = successData.response.daysOnTimeAndLeavesLeft;

      for (let i = 0; i < (successData.response.teamMembersToBeAdded).length; i++) {
        for (let j = 0; j < (successData.response.daysOnTimeAndLeavesLeft).length; j++) {
          if (successData.response.teamMembersToBeAdded[i].userId === successData.response.daysOnTimeAndLeavesLeft[j].userId) {
            this.teamMemberList.push({
              name: successData.response.teamMembersToBeAdded[i].name,
              leaveLeftCount: successData.response.daysOnTimeAndLeavesLeft[j].leavesLeft,
              countDaysOnTime: successData.response.daysOnTimeAndLeavesLeft[j].daysOnTime,
              memberUserID: successData.response.teamMembersToBeAdded[i].userId,
              memberSupervisorCheck: successData.response.teamMembersToBeAdded[i].isSupervisor
            })
            this.teamMemberUserId = this.teamMemberList[i].memberUserID;
            this.checkPendingRequest(this.teamMemberUserId)

            this.loading = false;
          }
        }
      }
      this.teamMemberList.forEach((currentTeamMember, indexForTeam) => {
        this.checkInModalData.forEach((checkIn, indexForCheckin) => {
          if (currentTeamMember.memberUserID == checkIn.userId) {
            this.teamMemberList[indexForTeam].isCheckIn = true;
          }
        });

        this.checkOutModalData.forEach((checkOut, indexForCheckout) => {
          if (currentTeamMember.memberUserID == checkOut.userId) {
            this.teamMemberList[indexForTeam].isCheckOut = true;
          }
        });

        this.absentModalData.forEach((absent, indexForCheckout) => {
          if (currentTeamMember.memberUserID == absent.userId) {
            this.teamMemberList[indexForTeam].isAbsent = true;
          }
        });

        this.pendingLeaveModalData.forEach((currentLeave, indexForCheckout) => {
          if (currentTeamMember.memberUserID == currentLeave.userId) {
            this.teamMemberList[indexForTeam].isLeave = true;
          }
        });
      });
    }, errorData => {
      if (errorData.error.status === 401) {
        this.router.navigate(['/login']);
        console.log("Please login first");
      } else if (errorData.error.status === 403 || errorData.error.status === 400) {
        this.error = errorData.error.message;
        console.log("ERROR: ", this.error);
      }
    })
  }

  setPage(page: number) {
    this.currentPage = page;
  }

  submitCheckInApproval() {
    const startIndex = (this.currentPage - 1) * this.recordsPerPage;
    const endIndex = startIndex + this.recordsPerPage;
    let dataToSubmit = this.particularUserCheckinData.slice(startIndex, endIndex);
    dataToSubmit = dataToSubmit.map(checkin => {
      let approvalStatus = '';

      if (checkin.status === "OK") {
        approvalStatus = 'OK';
      } else if (checkin.status === "Late") {
        approvalStatus = 'Late';
      } else if (checkin.status === "HalfDay") {
        approvalStatus = 'Half Day';
      } else if (checkin.status === "Unapproved") {
        approvalStatus = 'Unapproved Leave';
      }

      return {
        pendingId: checkin.pendingRequestId,
        approvalStatus: approvalStatus,
        approvedBy: this.name
      };
    });

    dataToSubmit = dataToSubmit.filter(item => item.approvalStatus !== '');
    if (dataToSubmit.length > 0) {
      this.serviceURLService.checkInSupervisor(dataToSubmit, this.teamMemberUserId).pipe(takeUntil(this.onDestroy$)).subscribe((successData: any) => {
        console.log("Supervisor Checked-in successfully");
        const pendingIds = new Set(dataToSubmit.map(item => item.pendingId));
        this.checkInModalData = this.checkInModalData.filter(item => !pendingIds.has(item.pendingRequestId));
        this.openCheckInModal(this.memberPopupUserId);
      }, errorData => {
        if (errorData.error.status === 401) {
          this.router.navigate(['/login']);
        } else if (errorData.error.status === 403 || errorData.error.status === 400) {
          this.error = errorData.error.message;
        }
      })
    }
  }

  submitCheckOutApproval() {
    const startIndex = (this.currentPage - 1) * this.recordsPerPage;
    const endIndex = startIndex + this.recordsPerPage;
    let dataToSubmit = this.particularUserCheckOutData.slice(startIndex, endIndex);
    dataToSubmit = dataToSubmit.map(checkin => {
      let approvalStatus = '';

      if (checkin.status === "OK") {
        approvalStatus = 'OK';
      } else if (checkin.status === "Late") {
        approvalStatus = 'Late';
      } else if (checkin.status === "HalfDay") {
        approvalStatus = 'Half Day';
      } else if (checkin.status === "Unapproved") {
        approvalStatus = 'Unapproved Leave';
      }

      return {
        pendingId: checkin.pendingRequestId,
        approvalStatus: approvalStatus,
        approvedBy: this.name
      };
    });

    dataToSubmit = dataToSubmit.filter(item => item.approvalStatus !== '');
    if (dataToSubmit.length > 0) {
      this.serviceURLService.checkOutSupervisor(dataToSubmit, this.teamMemberUserId).pipe(takeUntil(this.onDestroy$)).subscribe((successData: any) => {
        console.log("Supervisor Checked-out successfully");
        const pendingIds = new Set(dataToSubmit.map(item => item.pendingId));
        this.checkOutModalData = this.checkOutModalData.filter(item => !pendingIds.has(item.pendingRequestId)); 
        this.openCheckOutModal(this.memberPopupUserId);
      }, errorData => {
        if (errorData.error.status === 401) {
          this.router.navigate(['/login']);
        } else if (errorData.error.status === 403 || errorData.error.status === 400) {
          this.error = errorData.error.message;
        }
      })
    }
  }

  submitAbsentApproval(){
    const startIndex = (this.currentPage - 1) * this.recordsPerPage;
    const endIndex = startIndex + this.recordsPerPage;
    let dataToSubmit = this.particularUserAbsentData.slice(startIndex, endIndex);
    dataToSubmit = dataToSubmit.map(checkin => {
      let approvalStatus = '';

      if (checkin.status === "OK") {
        approvalStatus = 'OK';
      } else if (checkin.status === "Late") {
        approvalStatus = 'Late';
      } else if (checkin.status === "HalfDay") {
        approvalStatus = 'Half Day';
      } else if (checkin.status === "Unapproved") {
        approvalStatus = 'Unapproved Leave';
      }

      return {
        pendingId: checkin.pendingRequestId,
        approvalStatus: approvalStatus,
        approvedBy: this.name
      };
    });

    dataToSubmit = dataToSubmit.filter(item => item.approvalStatus !== '');
    if (dataToSubmit.length > 0) {
      this.serviceURLService.absentApprovalBySupervisor(dataToSubmit, this.teamMemberUserId).pipe(takeUntil(this.onDestroy$)).subscribe((successData: any) => {
        console.log("Supervisor Absent approval successfully");
        const pendingIds = new Set(dataToSubmit.map(item => item.pendingId));
        this.absentModalData = this.absentModalData.filter(item => !pendingIds.has(item.pendingRequestId));
        this.openAbsentApprovalModal(this.memberPopupUserId);
      }, errorData => {
        if (errorData.error.status === 401) {
          this.router.navigate(['/login']);
        } else if (errorData.error.status === 403 || errorData.error.status === 400) {
          this.error = errorData.error.message;
        }
      })
    }
  }
  
  refresh(): void {
    window.location.reload();
  }

  ngOnDestroy(): void {
    this.onDestroy$.next();
    this.onDestroy$.complete();
  }

}
